/** Shared types and key formatting for flight date-pair selection. */

export interface FlightPair {
  origin: string;
  destination: string;
  outbound_date: string;
  inbound_date: string | null;
  current_min: number;
  baseline_min: number | null;
  delta: number;
  pct: number | null;
  direction: 'up' | 'down' | 'flat';
  distinct_prices: number;
  currency: string;
}

export function pairKey(p: {
  origin: string;
  destination: string;
  outbound_date: string;
  inbound_date: string | null;
}): string {
  return `${p.origin}|${p.destination}|${p.outbound_date}|${p.inbound_date ?? ''}`;
}
